import React from "react";
import { Grid, Icon } from "semantic-ui-react";
import InputField from "../../../commonComponents/formComponents/inputField";
import DropDown from "../../../commonComponents/formComponents/dropDown";
import { useSelector } from "react-redux";
import { confirmAlert } from 'react-confirm-alert';
import { useCurrentShipmentType } from "../../../hooks/useCurrentShipmentType";
import { selectProcedure } from "../../selectors";
import { TranslateContext } from "../TranslateContext";
import CopyRepElement from "../../../GB_App/formSections/itemsTab/copyRepElement";

const AdditionalDocsDetails = ({item:{documentCode,statement,id},deleteData,updateData,saveData,isItemsTab,copyData}) => {
  const { isImportShipment, isDisabled }=useCurrentShipmentType()
  const additionalDocList = useSelector((state) => state.DropDownValues.additionalDocs);
  const procedure = useSelector(selectProcedure);
  const translate = React.useContext(TranslateContext).translate
  
  return (
    <Grid.Row>
      {isItemsTab && (
        <Grid.Column width={1} style={{textAlign:'center'}}>
          <CopyRepElement
            title='ADDITIONAL_DOC'
            request={{ documentCode,statement }}
            callback={copyData}
            isFormDisabled={isDisabled}
          />
        </Grid.Column>
      )}
      <Grid.Column
        width="7"
        className="divFormFeild border-bottom b-rw-0"
      >
        <DropDown
          id={`addDocs-${id}`}
          label={`addl. ${translate("DOC_CODE")}`}
          className="field-bg dropdown100"
          labelClass="text-none"
          isLabel={true}
          data={additionalDocList}
          clearable
          value={documentCode}
          onChange={(value) =>{
            const type=additionalDocList.find(c=>c.value==value)?.type
            let procList;
            if(!isImportShipment)
            procList=(type=="REF" || type=="TRA") ? ["B3", "B4"]:[]
            else if(isImportShipment)
            procList=(type=="REF" || type=="TRA" || type=="INF") ? ["I2"]:[]

            if((procList.includes(procedure))){
              confirmAlert({
                //title: `T cannot select ${type} if procedure is ${procList.join(',')}`,
                message: `${type} is not allowed if procedure code is ${procList.join(' or ')}`,
                buttons: [
                  {
                    label: 'OK'
                  }
                ]
              });
              
             return
            }
            
            saveData({id,documentCode:value})
            updateData(id,{"documentCode":value})}
          }
  
        />
      </Grid.Column>
      <Grid.Column
        width={isItemsTab? 7 : 8}
        className="divFormFeild  border-bottom"
      >
        <InputField
          isLabel={false}
          id={`addDocStatement-${id}`}
          type="text"
          label={`addl. ${translate("DOCUMENT_STATEMENT_IDENTIFICATION", {ns:["default", "header"]})}`}
          value={statement}
          className={"field-bg"}
          clearInput={false}
          onChange={(value) =>updateData(id,{"statement":value}) }
          onBlur={(value) =>saveData({id,statement:statement || " "}) }
      
        />
      </Grid.Column>

      <Grid.Column width="1" className="icon-delete-add-info">
        
          <span>
           
              <Icon
                id={`additionalDocs-delete-${id}`}
                name="trash alternate outline"
                onClick={() =>deleteData(id)}
              //  disabled={isFormDisabled}
              />
          
          </span>
       
      </Grid.Column>
    </Grid.Row>
  );
}
export default React.memo(AdditionalDocsDetails)
